/* eslint-disable no-unused-vars */
import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import SettingsIcon from "@mui/icons-material/Settings";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { PrintUtils } from "../../utils/PrintUtils";
import TerminalConfig from "../agent/TerminalConfig";
import StorageTwoToneIcon from "@mui/icons-material/StorageTwoTone";
import FlipTwoToneIcon from "@mui/icons-material/FlipTwoTone";
export default function BarcodePrintView_old(props) {
  const { t } = useTranslation();
  const translate = t;
  const [mode, setMode] = useState("view");
  const [numberOfPrints, setNumberOfPrints] = useState(1);
  const [printBarcodeFormat, setPrintBarcodeFormat] = useState(null);
  const [printShelfFormat, setPrintShelfFormat] = useState(null);
  const [printBarcodeFormatError, setPrintBarcodeFormatError] = useState("");
  const [printShelfFormatError, setPrintShelfFormatError] = useState("");
  const [showTerminalConfig, setShowTerminalConfig] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("barcodeFormat")) {
      setPrintBarcodeFormat(JSON.parse(localStorage.getItem("barcodeFormat")));
    } else {
      props.printBarcodeFormatOptions.map((value) => {
        if (value.name == "BARCODE_DEFAULT") {
          setPrintBarcodeFormat(value);
        }
      });
    }
  }, [props.printBarcodeFormatOptions]);

  useEffect(() => {
    if (localStorage.getItem("shelfLabelFormat")) {
      setPrintShelfFormat(JSON.parse(localStorage.getItem("shelfLabelFormat")));
    } else {
      props.printShelfFormatOptions.map((value) => {
        if (value.name == "SHELF_LABEL_DEFAULT") {
          setPrintShelfFormat(value);
        }
      });
    }
  }, [props.printShelfFormatOptions]);

  function onCloseWindow() {
    props.setShowBarcodePrintWindow(false);
  }
  function onSave() {}
  function onDelete() {}
  function isDataChanged() {
    return false;
  }
  function validate(type) {
    if ((type == "SHELF" && !printShelfFormat) || printShelfFormat === "") {
      setPrintShelfFormatError(translate("Print format is empty"));
      return false;
    }
    if (
      (type == "BARCODE" && !printBarcodeFormat) ||
      printBarcodeFormat === ""
    ) {
      setPrintBarcodeFormatError(translate("Print format is empty"));
      return false;
    }
    return true;
  }
  function onPrintShelfLabelClicked(barcode) {
    if (validate("SHELF")) {
      let shelfLabelPrinter = localStorage.getItem("w_shelfLabelPrinter");

      if (shelfLabelPrinter) {
        let storeDetails = localStorage.getItem("store");
        let storeInfoObject = null;
        if (storeDetails) storeInfoObject = JSON.parse(storeDetails);

        let printObject = Object.create(null);
        printObject.barcode = barcode;
        printObject.storeName = storeInfoObject
          ? storeInfoObject.shopName
          : null;
        printObject.contactNumber = storeInfoObject
          ? storeInfoObject.email
          : null;
        printObject.itemName = props.origObject.name;
        printObject.itemPrice = props.barcodeForPrint[5].v;

        printObject.promotionAmount = props.barcodeForPrint[8].promotionAmount;
        printObject.priceExPromotionExTax =
          props.barcodeForPrint[8].priceExPromotionExTax;
        printObject.priceRsp = props.barcodeForPrint[8].priceRsp;
        printObject.taxAmount = props.barcodeForPrint[8].taxAmount;
        printObject.factor = props.barcodeForPrint[1].v;
        printObject.qty = numberOfPrints;
        printObject.productInfoField1 = props.origObject.productInfoField1;
        printObject.productInfoField2 = props.origObject.productInfoField2;
        printObject.productInfoField3 = props.origObject.productInfoField3;
        printObject.productInfoField4 = props.origObject.productInfoField4;
        printObject.productInfoField5 = props.origObject.productInfoField5;
        printObject.productInfoField6 = props.origObject.productInfoField6;

        for (let i = 1; i <= 1; i++) {
          PrintUtils.printBarcode(
            "shelfLabelPrinter",
            printShelfFormat.name,
            printObject,
            translate,
            false,
            props.setAlert
          );
        }
      } else
        props.showMessage(
          "error",
          translate(
            "Shelf label printer Not Configured, Please use the setting button to configure"
          )
        );
      localStorage.setItem(
        "shelfLabelFormat",
        JSON.stringify(printShelfFormat)
      );
    } else props.showMessage("error", translate("Configuration error"));
  }
  function onPrintBarcodeClicked(barcode) {
    if (validate("BARCODE")) {
      let barcodePrinter = localStorage.getItem("w_barcodePrinter");

      if (barcodePrinter) {
        let storeDetails = localStorage.getItem("store");
        let storeInfoObject = null;
        if (storeDetails) storeInfoObject = JSON.parse(storeDetails);

        let printObject = Object.create(null);
        printObject.barcode = barcode;
        printObject.storeName = storeInfoObject
          ? storeInfoObject.shopName
          : null;
        printObject.contactNumber = storeInfoObject
          ? storeInfoObject.email
          : null;
        printObject.itemName = props.origObject.name;
        printObject.shortName = props.origObject.shortName;
        printObject.itemPrice = props.barcodeForPrint[5].v;
        printObject.factor = props.barcodeForPrint[1].v;
        printObject.promotionAmount = props.barcodeForPrint[8].promotionAmount;
        printObject.priceExPromotionExTax =
          props.barcodeForPrint[8].priceExPromotionExTax;
        printObject.priceRsp = props.barcodeForPrint[8].priceRsp;
        printObject.taxAmount = props.barcodeForPrint[8].taxAmount;
        printObject.factor = props.barcodeForPrint[1].v;
        printObject.qty = numberOfPrints;
        printObject.productInfoField1 = props.origObject.productInfoField1;
        printObject.productInfoField2 = props.origObject.productInfoField2;
        printObject.productInfoField3 = props.origObject.productInfoField3;
        printObject.productInfoField4 = props.origObject.productInfoField4;
        printObject.productInfoField5 = props.origObject.productInfoField5;
        printObject.productInfoField6 = props.origObject.productInfoField6;
        for (let i = 1; i <= 1; i++) {
          PrintUtils.printBarcode(
            "barcodePrinter",
            printBarcodeFormat.name,
            printObject,
            translate,
            false,
            props.setAlert
          );
        }
      } else
        props.showMessage(
          "error",
          translate(
            "Barcode printer Not Configured, Please use the setting button to configure"
          )
        );
      localStorage.setItem("barcodeFormat", JSON.stringify(printBarcodeFormat));
    } else props.showMessage("error", translate("Configuration error"));
  }
  function onConfigurePrinterClicked() {
    setShowTerminalConfig(true);
  }
  const content = (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="25%">{translate("Count")}</td>
                <td>
                  <PText
                    value={numberOfPrints}
                    onChange={(e) => setNumberOfPrints(e.target.value)}
                  ></PText>
                </td>
                <td align="center">
                  <Tooltip title={translate("Printer Configuration")}>
                    <IconButton onClick={() => onConfigurePrinterClicked()}>
                      <SettingsIcon />
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="25%">{translate("Shelf Label Format")}</td>
                <td style={{ paddingRight: "10px" }}>
                  <PSelect
                    options={props.printShelfFormatOptions}
                    value={printShelfFormat}
                    errorMessage={printShelfFormatError}
                    onChange={(event, newValue) => {
                      setPrintShelfFormatError("");
                      setPrintShelfFormat(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td width="25%">{translate("Barcode Format")}</td>
                <td style={{ paddingRight: "10px" }}>
                  <PSelect
                    options={props.printBarcodeFormatOptions}
                    value={printBarcodeFormat}
                    errorMessage={printBarcodeFormatError}
                    onChange={(event, newValue) => {
                      setPrintBarcodeFormatError("");
                      setPrintBarcodeFormat(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid container>
          <Grid item sm={12} xs={12}>
            <Card style={{ marginTop: 5 }}>
              <CardContent style={{ backgroundColor: "#f5f4f2" }}>
                <table width="100%">
                  {props.barcodeForPrint &&
                    props.barcodeForPrint[6].v.map((barcode) => (
                      <tr key={barcode}>
                        <td width="84%">
                          <PText
                            value={barcode}
                            readOnly={true}
                            //onChange={(e) => setPurchaseQty(e.target.value)}
                          ></PText>
                        </td>
                        <td width="8%">
                          <Tooltip title={translate("Shelf Label")}>
                            <IconButton
                              color="secondary"
                              onClick={() => onPrintShelfLabelClicked(barcode)}
                            >
                              <StorageTwoToneIcon />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td width="8%">
                          <Tooltip title={translate("Print Barcode")}>
                            <IconButton
                              color="secondary"
                              onClick={() => onPrintBarcodeClicked(barcode)}
                            >
                              <FlipTwoToneIcon />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                </table>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  const displayConfig = {
    showTerminalKey: true,
    showReceiptPrinter: false,
    showBarcodePrinter: true,
    showPoleDisplay: false,
    showReportPrinter: false,
    showShelfLabelPrinter: true,
  };

  return (
    <div>
      <PDialog
        content={content}
        title={"Print Barcode & Shelf Label"}
        maxWidth={"sm"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        onDelete={onDelete}
        mode={mode}
        isDataChanged={isDataChanged}
      ></PDialog>
      {showTerminalConfig && (
        <TerminalConfig
          openFrom="PRODUCT"
          showMessage={props.showMessage}
          displayConfig={displayConfig}
          setShowTerminalConfig={setShowTerminalConfig}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
        ></TerminalConfig>
      )}
    </div>
  );
}
